/**
 * 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SortExpression } from './sort-expression';
import { NotificationStatuses } from './notification-statuses';
import { DateTimePeriod } from './date-time-period';
import { Channels } from './channels';


export interface SearchNotificationHistoryRequest { 
    skip?: number;
    take?: number;
    includeTotalCount?: boolean | null;
    sortExpressions?: Array<SortExpression> | null;
    keyword?: string | null;
    channels?: Array<Channels> | null;
    datePeriod?: DateTimePeriod;
    statuses?: Array<NotificationStatuses> | null;
}

